            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">      
        <b-form  inline style="margin-bottom:15px" novalidate>          
            <div>
              <b-row class="p-2">
                <sw-inputs
                  inputTabla="info_afiliacion"
                  inputCampo="id_list_novedad"
                  @input="changeNovedad"
                  :md="2" :lg="2">
                </sw-inputs> 
                <sw-inputs
                inputTabla="info_afiliacion"
                inputCampo="dias"
                  :md="2" :lg="2">
                </sw-inputs>     
                <sw-inputs
                inputTabla="info_afiliacion"
                inputCampo="salario"
                @input="changeNovedad"
                  :md="2" :lg="2">
                </sw-inputs>   
                <sw-inputs
                inputTabla="info_afiliacion"
                inputCampo="id_datos_razon"
                  :md="2" :lg="2">
                </sw-inputs>                     
                <sw-inputs
                  inputTabla="info_afiliacion"
                  inputCampo="id_datos_asesor"
                  :md="2" :lg="2">
                </sw-inputs>
                <sw-inputs
                  inputTabla="info_afiliacion"
                  inputCampo="id_datos_contacto"
                  :md="2" :lg="2">
                </sw-inputs>  
                <b-col :md="12" :lg="12" v-if="dataForm[namePath].info_afiliacion.id_list_novedad===3 || dataForm[namePath].info_afiliacion.id_list_novedad===1">
                  <b-row style="background: rgba(0,80,166, 0.03);padding-bottom: 20px">
                      <b-col
                        :md="4" :lg="4">
                        <b-form-group
                          label="Salario proporcional"
                        >
                          <b-input-group size="sm" prepend="$">
                          <vue-numeric v-model="salarioproporcional" separator="."  disabled trim></vue-numeric>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <sw-inputs
                        v-if="(novedad===1 && dataForm[namePath].info_afiliacion.id_list_novedad===3) || dataForm[namePath].info_afiliacion.id_list_novedad===1 "
                        inputTabla="info_afiliacion"
                        inputCampo="ingreso"
                        @input="changeIngreso"
                        :md="4" :lg="4">
                      </sw-inputs>                             
                      <sw-inputs
                        v-if="dataForm[namePath].info_afiliacion.id_list_novedad===3"
                        inputTabla="info_afiliacion"
                        inputCampo="retiro"
                        @input="changeRetiro"
                        :md="4" :lg="4">
                      </sw-inputs>
                  </b-row>  
                </b-col>    
              </b-row>  
              <b-alert show variant="warning" v-if="dataForm[namePath].servicios_nuevos.length>0">El afiliado tiene los servicios de {{pendientesAfiliado(dataForm[namePath].servicios_nuevos)}} pendientes del radicado de afiliación.</b-alert> 
              <b-row> 
                <b-col :md="5">
                    <h5 class="title-form">Datos Afiliado</h5>
                    <b-row>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="info_afiliacion"
                      inputCampo="id_list_tipo"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="info_afiliacion"
                      inputCampo="id_list_subtipo"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="datos_afiliado"
                      inputCampo="id_list_documento"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="datos_afiliado"
                      inputCampo="documento"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="datos_afiliado"
                      inputCampo="nombre1"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="datos_afiliado"
                      inputCampo="nombre2"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="datos_afiliado"
                      inputCampo="apellido1"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="datos_afiliado"
                      inputCampo="apellido2"
                      :md="6" :lg="6">
                      </sw-inputs>                      
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="datos_afiliado"
                      inputCampo="direccion"
                      :md="12" :lg="12">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="datos_afiliado"
                      inputCampo="ciudad"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      inputTabla="datos_afiliado"
                      inputCampo="telefonos"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      style="margin-top:8px"
                      inputTabla="info_afiliacion"
                      inputCampo="exonerado"
                      :md="6" :lg="6">
                      </sw-inputs>
                      <sw-inputs
                      class="aporteDatosAfiliado"
                      style="margin-top:8px"
                      inputTabla="datos_afiliado"
                      inputCampo="planilla"
                      :md="6" :lg="6">
                      </sw-inputs>
                    </b-row>
                  </b-col> 
                  <b-col :md="7"  v-if="dataForm[namePath].servicios_activos.length>0">
                    <h5 class="title-form">Servicios</h5>  
                    <sw-tablemultiple
                      v-if="dataForm[namePath].info_afiliacion.id_list_novedad===1"
                      getTable="multiple_servicios"
                      :hideServicio="['Traslado']"
                      :views="[
                        { th:'Select.', td: 'check'},
                        { th:'Servicio', td: 'name'},
                        { th:'Entidad', td: 'id_list'},
                        { th:'Valor', td: 'valoringreso'},
                      ]"
                      >
                    </sw-tablemultiple>
                  <sw-tablemultiple
                      v-if="dataForm[namePath].info_afiliacion.id_list_novedad===2 || dataForm[namePath].info_afiliacion.id_list_novedad===4"
                      getTable="multiple_servicios"
                      :hideServicio="['Traslado']"
                      :views="[
                        { th:'Select.', td: 'check'},
                        { th:'Servicio', td: 'name'},
                        { th:'Entidad', td: 'id_list'},
                        { th:'Valor', td: 'valor'},
                      ]"
                      >
                    </sw-tablemultiple>   
                  <sw-tablemultiple
                      v-if="dataForm[namePath].info_afiliacion.id_list_novedad===3"
                      getTable="multiple_servicios"
                      :hideServicio="['Traslado']"
                      :views="[
                        { th:'Select.', td: 'check'},
                        { th:'Servicio', td: 'name'},
                        { th:'Entidad', td: 'id_list'},
                        { th:'Valor', td: 'valorretiro'},
                      ]"
                      >
                    </sw-tablemultiple>                    
                  </b-col>   
              </b-row>
            </div>  
        </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
        <b-row style="width:100%" align-v="center">
          <b-col>
            <p  class="text-danger" style="padding-top:10px" v-if="errorsAportes">* {{errorsAportes}}</p> 
          </b-col>
          <b-col :md="3" :lg="3">
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn=""
              :invalid="invalid || invalidNovedad()"
              @save="save"
              >
            </sw-saveform>
          </b-col>
        </b-row>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import moment from 'moment'
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwModallistforma  from '@/components/modals/list_forma.vue'
import SwModallistcuentas  from '@/components/modals/list_cuentas.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTablemultiple  from '@/components/dataTable/tableMultiple.vue'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    SwModallistforma,
    SwModallistcuentas,
    SwTablemultiple,
    VueNumeric  
  },
  props: {
  },
  data()
  {
    return {     
			dias: 30,
			ingresoccf: null,
			salarioccf: 0,
			indexccf: -1,
			salarioBase: 0,
			ingreso: null,
      errorsAportes: null,
      novedad:null,
      salarioproporcional: 0
    }
  },
  async created(){    
    if(this.namePath==='aportes_registrar' || this.namePath==='aportes_cuentas' || this.namePath==='archivo_retiros')
    {	
      const await01 = this.updateDataForm({state: 'precios', data: await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1}) })
      const await02 = this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })      
      const await03 = this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})

      await Promise.all([await01,await02,await03])

      for (let i = 0; i < this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos.length; i++) {       
          if(this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos[i].nota_delete===null)
          {
            let indexMultiple=_.findIndex(this.dataMultiple[this.namePath].multiple_servicios, ['name',this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos[i].name])
            if(indexMultiple!==-1)
            {
              this.$set(this.dataMultiple[this.namePath].multiple_servicios,indexMultiple,this.deepCopy(this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos[i]))
            }
				  	
          }
			}

      const await1 = this.updateDataForm({state: 'datos_afiliado', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado})
      const await2 = this.updateDataForm({state: 'info_afiliacion', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_afiliacion})
      const await3 = this.updateDataForm({state: 'servicios_activos', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos})
      const await4 = this.updateDataForm({state: 'servicios_nuevos', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_nuevos})
      
      await Promise.all([await1,await2,await3,await4])
      
      this.novedad=this.dataForm[this.namePath].info_afiliacion.id_list_novedad
      this.ingreso=this.dataForm[this.namePath].info_afiliacion.ingreso			
			this.salarioBase=this.dataForm[this.namePath].info_afiliacion.salariobase

    } 
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  async destroyed()
  {
      await this.resetDataIndex()
  },
  computed: { 
  },
  methods: {
    async save(event)
    {   
      try {
        let newServicios= [] 
        let indexAdmin = _.findIndex(this.dataForm[this.namePath].servicios_activos,['name','Administración'])
        for(let i=0;i<this.dataMultiple[this.namePath].multiple_servicios.length;i++)
        {
          if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1)
          {				
            let newValue= this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
            let indexServiciosActivos=_.findIndex(this.dataForm[this.namePath].servicios_activos,['name',this.dataMultiple[this.namePath].multiple_servicios[i].name])
            if(indexServiciosActivos===-1 && this.namePath!=='archivo_retiros')
            {
              newValue.id=null
              newValue.mes_periodo=this.dataForm[this.namePath].info_afiliacion.mes_periodo
              newValue.ano_periodo=this.dataForm[this.namePath].info_afiliacion.ano_periodo
              newValue.id_info_ingresos=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].afiliacion_registro.id_info_ingresos
              newValue.id_afiliacion_registro=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].afiliacion_registro.id
              newValue.id_info_afiliacion=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_afiliacion.id
              newValue.archivo=[]
              newValue.lock=1
            }	
            if(indexServiciosActivos===-1 && this.namePath==='archivo_retiros')
            {
              newValue.id=null
              newValue.mes_periodo=this.dataForm[this.namePath].info_afiliacion.mes_periodo
              newValue.ano_periodo=this.dataForm[this.namePath].info_afiliacion.ano_periodo
              newValue.id_info_ingresos=this.dataForm[this.namePath].servicios_activos[indexAdmin].id_info_ingresos
              newValue.id_afiliacion_registro=this.dataForm[this.namePath].servicios_activos[indexAdmin].id_afiliacion_registro
              newValue.id_info_afiliacion=this.dataForm[this.namePath].servicios_activos[indexAdmin].id_info_afiliacion
              newValue.archivo=[]
              newValue.lock=1
            }			
            else if(this.namePath==='archivo_retiros')
            {         
              newValue= this.deepCopy(this.dataForm[this.namePath].servicios_activos[indexServiciosActivos])    
              newValue.nota_delete=null
              newValue.deleted_at=null
            }		
            newServicios.push(newValue)						
          }
          else
          {          
            let indexGetActivos = _.filter(this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos,{'name':this.dataMultiple[this.namePath].multiple_servicios[i].name,'nota_delete':null})
            if(indexGetActivos.length>0 && this.namePath==='archivo_retiros')
            {            
              let newValue=this.deepCopy(indexGetActivos[0])
              newValue.deleted_at=this.fecha().fecha.delete
              newValue.nota_delete='archivo plano retiros'
              newServicios.push(newValue)	
            }
          }   
        }
        await this.updateDataForm({state: 'servicios_activos', data: newServicios})
        this.$emit('save',{save: false,ftn: 'editarAportesFtn'})
      } catch(e) {
        console.log(e)
      }
    },
		async changeNovedad()
		{
			if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
			{
				await this.changeIngreso()
			}
			if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===2)
			{
				await this.updateDataForm({state: 'info_afiliacion/dias', data: 30})
			}
			if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
			{
				await this.changeRetiro()
			}
		},
		async changeIngreso()
		{				
			if(this.ingreso!==null)
			{
				if(this.dataForm[this.namePath].info_afiliacion.ingreso==='' || this.dataForm[this.namePath].info_afiliacion.ingreso===null)
				{
					this.dataForm[this.namePath].info_afiliacion.ingreso=this.ingreso
				}
				let dias= moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('DD')
				if(dias>30)
				{
					dias=30
				}
				dias=31-dias
				let salario=(this.salarioBase/30)*dias
				this.salarioproporcional=salario
				await this.updateDataForm({state: 'info_afiliacion/dias', data: dias})
			}			
			
			return true			
			
    },
		async changeRetiro()
		{	
			let dias
			let salario			
			if(this.dataForm[this.namePath].info_afiliacion.retiro==='' || this.dataForm[this.namePath].info_afiliacion.retiro===null)
			{
				if(this.novedad===1)
				{
					this.dataForm[this.namePath].info_afiliacion.retiro=this.dataForm[this.namePath].info_afiliacion.ingreso
					dias= 1		
					salario=(this.salarioBase/30)*dias	
				}else 
				{
					this.dataForm[this.namePath].info_afiliacion.retiro=this.fecha(this.dataForm[this.namePath].info_afiliacion.ano_periodo+'-'+this.dataForm[this.namePath].info_afiliacion.mes_periodo+'-01').fecha.retPrimero
					dias= 1			
					salario=(this.salarioBase/30)*dias	
				}				
			}
			else 
			{
				let fecha11=moment(this.dataForm[this.namePath].info_afiliacion.ingreso)
				let fecha21=moment(this.dataForm[this.namePath].info_afiliacion.retiro)
				let dias1=parseInt(fecha21.diff(fecha11, 'months'))

				if(dias1===0)
				{
					this.novedad=1
					let mesretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('MM'))+1
					let anoretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('YYYY'))
					let diaretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('DD'))
					if(diaretiro===31)
					{
						this.dataForm[this.namePath].info_afiliacion.retiro=this.fecha(anoretiro+'-'+mesretiro+'-30').fecha.retUltimo
					}
					let fecha1=moment(this.dataForm[this.namePath].info_afiliacion.ingreso)
					let fecha2=moment(this.dataForm[this.namePath].info_afiliacion.retiro)
					dias=parseInt(fecha2.diff(fecha1, 'days'))+1
					if(dias<=0)
					{
						this.dataForm[this.namePath].info_afiliacion.retiro=this.dataForm[this.namePath].info_afiliacion.ingreso
						dias=1
					}
					salario=(this.salarioBase/30)*dias
				}else{
					let mesretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('MM'))+1
					let anoretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('YYYY'))
          let diaretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('DD'))
          
					if(mesretiro===13) 
					{
						mesretiro=1
						anoretiro=anoretiro+1
          } 
          if(diaretiro===31)
					{
						this.dataForm[this.namePath].info_afiliacion.retiro=this.fecha(anoretiro+'-'+mesretiro+'-30').fecha.retUltimo
					}
					if(this.dataForm[this.namePath].info_afiliacion.ano_periodo!==anoretiro || this.dataForm[this.namePath].info_afiliacion.mes_periodo!=mesretiro)
					{
						this.dataForm[this.namePath].info_afiliacion.retiro=this.fecha(this.dataForm[this.namePath].info_afiliacion.ano_periodo+'-'+this.dataForm[this.namePath].info_afiliacion.mes_periodo+'-01').fecha.retPrimero
						dias= 1	
					}
					else 
					{
						dias= moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('DD')
					}			
					salario=(this.salarioBase/30)*dias					
				}
			}
			
			this.salarioproporcional=salario
			await this.updateDataForm({state: 'info_afiliacion/dias', data: dias})
			
			return true
			
		},
		async changeRetiros()
		{	
			let dias
			let salario			
			if(this.dataForm[this.namePath].info_afiliacion.retiro==='' || this.dataForm[this.namePath].info_afiliacion.retiro===null)
			{
				if(this.novedad===1)
				{
					this.dataForm[this.namePath].info_afiliacion.retiro=this.dataForm[this.namePath].info_afiliacion.ingreso
					dias= 1		
					salario=(this.salarioBase/30)*dias	
				}else 
				{
					this.dataForm[this.namePath].info_afiliacion.retiro=this.fecha(this.dataForm[this.namePath].info_afiliacion.ano_periodo+'-'+this.dataForm[this.namePath].info_afiliacion.mes_periodo+'-01').fecha.retPrimero
					dias= 1			
					salario=(this.salarioBase/30)*dias	
				}				
			}
			else 
			{
				if(this.novedad===1)
				{
					let fecha1=moment(this.dataForm[this.namePath].info_afiliacion.ingreso)
					let fecha2=moment(this.dataForm[this.namePath].info_afiliacion.retiro)
					dias=parseInt(fecha2.diff(fecha1, 'days'))+1
					if(dias<=0)
					{
						this.dataForm[this.namePath].info_afiliacion.retiro=this.dataForm[this.namePath].info_afiliacion.ingreso
						dias=1
					}
					salario=(this.salarioBase/30)*dias
				}else{					
					              
					let mesretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('MM'))+1
					let anoretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('YYYY'))
					if(mesretiro===13) 
					{
						mesretiro=1
						anoretiro=anoretiro+1
					} 
					if(this.dataForm[this.namePath].info_afiliacion.ano_periodo!==anoretiro || this.dataForm[this.namePath].info_afiliacion.mes_periodo!=mesretiro)
					{
						this.dataForm[this.namePath].info_afiliacion.retiro=this.fecha(this.dataForm[this.namePath].info_afiliacion.ano_periodo+'-'+this.dataForm[this.namePath].info_afiliacion.mes_periodo+'-01').fecha.retPrimero
						dias= 1	
					}
					else 
					{
						dias= moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('DD')
					}			
					salario=(this.salarioBase/30)*dias					
				}
			}
			
			this.salarioproporcional=salario
			await this.updateDataForm({state: 'info_afiliacion/dias', data: dias})
			
			return true			
		},
    async changeSalario()
		{	
			try{
				if(this.salarioBase!==this.dataForm[this.namePath].info_afiliacion.salario)
				{
					this.salarioBase=this.dataForm[this.namePath].info_afiliacion.salario			
					if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
					{
						await this.changeIngreso()
					}
					if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===2)
					{
						await this.updateDataForm({state: 'info_afiliacion/dias', data: 30})
					}
					if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
					{
						await this.changeRetiro()
					}
				}
				return true
			} catch(e){
				console.log(e)
			}				
		},
		invalidNovedad()
		{
			if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
			{		
				let fecha1=moment(this.dataForm[this.namePath].info_afiliacion.ingreso)
				let fecha2=moment(this.dataForm[this.namePath].info_afiliacion.ano_periodo+'-'+this.dataForm[this.namePath].info_afiliacion.mes_periodo+'-30')
				let diff= parseInt(fecha2.diff(fecha1, 'months'))
				if(diff!==1)
				{
					this.errorsAportes='El inicio de labores no concuerda con el periodo de aporte'
					return true
				}	
			}
			if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
			{		
				let fecha1=moment(this.dataForm[this.namePath].info_afiliacion.retiro)
				let fecha2=moment(this.dataForm[this.namePath].info_afiliacion.ano_periodo+'-'+this.dataForm[this.namePath].info_afiliacion.mes_periodo+'-30')
				let diff= parseInt(fecha2.diff(fecha1, 'months'))
				if(diff!==1)
				{
					this.errorsAportes='La fecha de retiro no concuerda con el periodo de aporte'
					return true
				}	
			}
			if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===4)
			{		
				let indexAfp=_.findIndex(this.dataMultiple[this.namePath].multiple_servicios,{'name':'Afp','check':1})			
				if(indexAfp===-1)
				{
					this.errorsAportes='Para generar un retiro solo AFP debe seleccionar y asignar una AFP'
					return true
				}	
			}
			
			let ninguno= 'Debe asignar la entidad de: '
			for(let i=0;i<this.dataMultiple[this.namePath].multiple_servicios.length;i++)
			{
				if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1 && (this.dataMultiple[this.namePath].multiple_servicios[i].name==='Eps' || this.dataMultiple[this.namePath].multiple_servicios[i].name==='Afp' || this.dataMultiple[this.namePath].multiple_servicios[i].name==='Ccf') && this.predeterminados[this.namePath].multiple_servicios[i].id_list.toString()===this.dataMultiple[this.namePath].multiple_servicios[i].id_list.toString())
				{			
					ninguno=ninguno+' *'+this.dataMultiple[this.namePath].multiple_servicios[i].name+' '								
				}   
			}
			if(ninguno!=='Debe asignar la entidad de: ')
			{
				this.errorsAportes=ninguno
				return true
			}
			
			this.errorsAportes=null
			return false
    },
		pendientesAfiliado(data)
		{
			let name = ''
			for (let i = 0; i < data.length; i++) {
				name += data[i].name+', ';				
			}
			return name
		}
  }
}
</script>
<style>
.modal-lg
{
  max-width: 950px !important;
}
</style>